module.exports = __webpack_public_path__ + "img/suit-03.6d4eccf0.png";